import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import { getSource } from 'utils/api';
import moment from 'moment';
import { Button, Input } from 'reactstrap';
import './style.scss';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import { textTruncateByLength } from 'utils/other';

const ItemsOnPageAfterPagination = 50;
const paginationButtonsCount = 5;
const paginationButtonsBoundary = 2;

const FeedPreviewModal = ({ feed, getFeedsList, modalType }) => {
    const [feedSource, setFeed] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [showBtn, setMode] = useState(false);
    const [name, handleName] = useState('');
    const [feedNameLoading, setFeedNameLoading] = useState(false);
    const [nameChanged, setNameChanged] = useState(false);
    const [nameForPreventUNNECESSARYApiCalls, setDefaultName] = useState('');
    const [activePage, changePagination] = useState(1);
    
    useEffect(() => {
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getData = () => {
        if(modalType === 'feed') {
            getFeed();
            handleName(feed.name);
            setDefaultName(feed.name); 
        } //else if(modalType === 'group') {
            //getGroup();
            //handleName(feed.title);
            //setDefaultName(feed.title); 
        //}
    }

    const getFeed = async () => {
        try {
            let source = await getSource(feed.id);
            source = [...source.content.result];

            source.sort((a, b) => {
                if (b.publishedAt === null || a.publishedAt === null || b.abstract === null || a.abstract === null) {
                    return 0;
                }

                return b.publishedAt.date.localeCompare(a.publishedAt.date);
            });

            setFeed(source);
        } catch (e) {
            if(e.message.length < 150) {
                toast.error(e.message);
                throw e.message;
            }
        }
    };

    // const getGroup = async () => {
    //     try {
    //         let source = await getGroupForListPreview(feed.id);
    //         source = [...source.content];
            
    //         source.sort((a, b) => {
    //             let aConverted = a.publishedAt.date;
    //             let bConverted = b.publishedAt.date;
    //             if(!a.is_web_news) {
    //                 let stillUtc = moment.utc(aConverted).toDate();
    //                 aConverted = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');
    //             } else {
    //                 aConverted = moment(aConverted).format('YYYY-MM-DD HH:mm:ss');
    //             }
    //             if(!b.is_web_news) {
    //                 let stillUtc = moment.utc(bConverted).toDate();
    //                 bConverted = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');
    //             } else {
    //                 aConverted = moment(aConverted).format('YYYY-MM-DD HH:mm:ss');
    //             }

    //             return moment(bConverted) - moment(aConverted);
    //         });

    //         setFeed(source);
    //     } catch (e) {
    //         if(e.message.length < 150) {
    //             toast.error(e.message);
    //             throw e.message;
    //         }
    //     }
    // };

    const toTop = (e) => {
        if (e.nativeEvent.target.tagName === 'I') {
            return (e.nativeEvent.target.parentElement.parentElement.scrollTop = 0);
        }
        e.nativeEvent.target.parentElement.scrollTop = 0;
    };

    const handleCheckScroll = (e) => {
        const scrollCoordinates = e.nativeEvent.target.scrollTop;
        if (scrollCoordinates > 300) {
            setMode(true);
        } else {
            setMode(false);
        }
    };

    const convertDateString = (date, item) => {
        if(modalType === 'feed') {
            //if(feed.discriminator !== 'web_resource') {
                //let stillUtc = moment.utc(date).toDate();
                //return moment(stillUtc).local().format(`MMMM DD, YYYY ${!date.includes('00:00:00.000000') ? 'hh:mm A' : ''}`);
            //} else {
                return moment(date).format(`MMMM DD, YYYY ${!date.includes('00:00:00.000000') ? 'hh:mm A' : ''}`);
            //}
        } else if(modalType === 'group') {
            if(!item.is_web_news) {
                let stillUtc = moment.utc(date).toDate();
                return moment(stillUtc).local().format(`MMMM DD, YYYY ${!date.includes('00:00:00.000000') ? 'hh:mm A' : ''}`);
            } else {
                return moment(date).format(`MMMM DD, YYYY ${!date.includes('00:00:00.000000') ? 'hh:mm A' : ''}`);
            }
        }
    };

    const handleNameChange = (value) => {
        handleName(value);
        setNameChanged(true);
    }

    // const saveNewFeedName = async () => {
    //     if(nameChanged) {
    //         setFeedNameLoading(true);
    //         try {
    //             const params = {
    //                 feedName: name,
    //             }
    //             const backFeedName = await saveFeedName(feed.id, params);
    //             handleName(backFeedName.content.name);
    //             setEditMode(false);
    //             setFeedNameLoading(false);
    //             setNameChanged(false);
    //             getFeedsList();
    //             toast.success('Newsfeed name successfuly changed');
    //         } catch(err) {
    //             setFeedNameLoading(false);
    //             toast.error(err);
    //             throw err;
    //         }
    //     } else {
    //         setNameChanged(false);
    //         setEditMode(false);
    //     }
    // }

    const cancelFeedNameEditing = async () => {
        /*if(nameChanged) {  // correct way of making cancel
            setFeedNameLoading(true);
            try {
                const oldName = await getFeedNameById(feed.id, feed.discriminator);
                handleName(oldName.content.feedName);
                setEditMode(false);
                setFeedNameLoading(false);
                setNameChanged(false);
            } catch(err) {
                setFeedNameLoading(false);
                toast.error(err);
                throw err;
            }
        } else {
            setNameChanged(false);
            setEditMode(false);
        }*/
        handleName(nameForPreventUNNECESSARYApiCalls); //stupid way of making cancel that dont have any backend sync
        setNameChanged(false);
        setEditMode(false);
    }

    const createPagination = () => {
        //TODO: need to move pages from this func to component scope-> didmount didupdate
        const pages = Math.ceil(feedSource.length / ItemsOnPageAfterPagination);
        const array = [];

        for (let i = 1; i <= pages; i++) {
            if(pages > paginationButtonsCount) {
                if (activePage <= paginationButtonsBoundary + 1 && i <= paginationButtonsCount) {
                    //active is in []
                    //to make items like [1] 2 3 4 5
                    array.push(i);
                } else if (activePage >= pages - paginationButtonsBoundary && i > pages - paginationButtonsCount) {
                    //to make items like 7 8 9 10 [11]
                    array.push(i);
                } else if (i >= activePage - paginationButtonsBoundary && i <= activePage + paginationButtonsBoundary) {
                    //to make items like 4 5 [6] 7 8
                    array.push(i);
                }
            } else {
                array.push(i);
            }
        }
        return array.map((item) => (
            <li 
                key={item} 
                style={{ cursor: 'pointer' }} 
                onClick={() => changePagination(item)} 
                className={`page-item ${item === activePage && 'active'}`}
            >
                <div className="page-link">{item}</div>
            </li>
        ));
    };

    const handlePaginationChange = (pageNumber) => {
        //TODO: need to move pages from this func to component scope-> didmount didupdate
        const pages = Math.ceil(feedSource.length / ItemsOnPageAfterPagination);
        if (pageNumber > pages || pageNumber < 1) {
            return false;
        } else {
            changePagination(pageNumber);
        }
    };

    const getFilteredList = (list) => {
        const maxCounterOnPage = activePage * ItemsOnPageAfterPagination;

        return list.map((news, index) => (index >= maxCounterOnPage - ItemsOnPageAfterPagination && index < maxCounterOnPage) && (
                <div className="news" key={index} style={{ marginBottom: '12px' }}>
                    <a className="news_link" target="blank" href={news.link}>
                        {news.title && textTruncateByLength(news.title, 140)}
                    </a>
                    <br />
                    {news.domain &&
                        <span style={{ color: '#869fac', fontSize: '.775rem' }}>
                            {news.domain + ' • '}
                        </span>
                    }
                    {news.publishedAt && news.publishedAt.date && (
                        <span style={{ color: '#869fac', fontSize: '.775rem' }}>
                            {convertDateString(news.publishedAt.date, news) + '  '}
                        </span>
                    )}
                    {news.authorScreenName && (
                        <a 
                            target="_blank"
                            rel="noopener noreferrer"
                            href={news.authorLink} 
                            style={{ color: '#869fac', fontSize: '.775rem', textDecoration: 'underline' }}
                        >
                            {news.authorScreenName}
                        </a>
                    )}
                    {news.authorFollowersCount && (
                        <span style={{ color: '#869fac', fontSize: '.775rem' }}>
                            {' (' + news.authorFollowersCount + ')'}
                        </span>
                    )}
                    {news.abstract && (
                        <React.Fragment>
                            <br />
                            <span>{textTruncateByLength(news.abstract, 300)}</span>
                        </React.Fragment>
                    )}
                </div>
            )
        )
    }

    return (
        <Wrapper>
            <div>
                <h3>Newsfeed Preview:</h3>
                {feedNameLoading ? (
                    <div> Loading </div>
                ) : (
                    <div className="feedPreview-header">
                    {feed.discriminator === 'web_resource' ? (
                        <React.Fragment>
                            <div className="preview-input-container">
                                {editMode ? (
                                    <Input 
                                        className="inputFeedName" 
                                        value={name} 
                                        onChange={(e) => handleNameChange(e.target.value)} 
                                    /> 
                                ) : (
                                    <h5>{name}</h5>
                                )}
                            </div>
                            <React.Fragment>
                                {editMode ? (
                                    <div style={{ display: 'flex' }}>
                                        <Button 
                                            style={{ marginRight: '5px' }}
                                            onClick={() => {}} 
                                            className="btn typical-button"
                                            disabled={name.trim().length < 1}
                                        >
                                            Save
                                        </Button>
                                        <Button 
                                            onClick={() => cancelFeedNameEditing()} 
                                            className="btn typical-button "
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                ) : (
                                    <Button onClick={() => setEditMode(true)} className="btn typical-button ">
                                        Rename
                                    </Button>
                                )}
                            </React.Fragment>
                        </React.Fragment>
                    ) : (
                        <h5>{name}</h5>
                    )}
                    </div>
                )}
            </div>
            <div className="modal-wrapper_container" onScroll={(e) => handleCheckScroll(e)}>
                {!feedSource ? (
                    <i className="fa fa-spinner fa-spin" />
                ) : feedSource.length ? (
                    getFilteredList(feedSource)
                ) : (
                    <div style={{ fontWeight: '700' }}>This Newsfeed is not available yet. Please check again later for updated content.</div>
                )}
                {showBtn && (
                    <Button onClick={(e) => toTop(e)} style={{ color: 'white', right: '40px', bottom: '80px' }} className="btnBackToTop">
                        <i className="fas fa-arrow-up" />
                    </Button>
                )}
            </div>
            {feedSource && feedSource.length > 0 && createPagination().length > 1 && (
                <nav 
                    className="d-flex flex-column align-items-center" 
                    style={{ display: 'flex', justifyContent: 'center', padding: '10px 0', borderTop: '1px solid #c8ced3' }} 
                    aria-label="Page navigation"
                >
                    <ul className="pagination" style={{ marginBottom: '0' }}>
                        <li className="page-item">
                            <div
                                className="page-link"
                                style={{
                                    color: '#314784',
                                    cursor: 'pointer',
                                }}
                                onClick={() => handlePaginationChange(1)}
                            >
                                <i className="fas fa-angle-double-left" />
                            </div>
                        </li>
                        <li className="page-item">
                            <div
                                className="page-link"
                                style={{
                                    color: '#314784',
                                    cursor: 'pointer',
                                }}
                                onClick={() => handlePaginationChange(activePage - 1)}
                            >
                                <i className="fas fa-angle-left" />
                            </div>
                        </li>
                        {createPagination()}
                        <li className="page-item">
                            <div
                                className="page-link"
                                style={{
                                    color: '#314784',
                                    cursor: 'pointer',
                                }}
                                onClick={() => handlePaginationChange(activePage + 1)}
                            >
                                <i className="fas fa-angle-right" />
                            </div>
                        </li>
                        <li className="page-item">
                            <div
                                className="page-link"
                                style={{ color: '#314784', cursor: 'pointer' }}
                                onClick={() => handlePaginationChange(Math.ceil(feedSource.length / ItemsOnPageAfterPagination))}
                            >
                                <i className="fas fa-angle-double-right" />
                            </div>
                        </li>
                    </ul>
                </nav>
            )}
        </Wrapper>
    );
};

export default withRouter(FeedPreviewModal);
